// src/app/job-description-model-popup/job-description-model-popup.component.ts

import { Component, Input, ViewChild, ElementRef, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetInput } from '../Models/job-like-job.model';
import { StripHtmlPipe,SafeEmbedHtmlPipe } from '../pipes/Angular-commonUtil.pipe';



@Component({
  selector: 'job-description-model-popup',
  standalone: true,
  imports: [CommonModule,StripHtmlPipe,SafeEmbedHtmlPipe],
  templateUrl: './job-description-model-popup.component.html',
  styleUrls: ['./job-description-model-popup.component.scss']
})
export class JobDescriptionModelPOPUPComponent {
  @ViewChild('modalContent') modalContent!: ElementRef;
  @ViewChild('modalStart') closeButton!: ElementRef;
  pagetype: string = '';
  translateStrings: any = {};
  jobdescpritionAndTitle: { JobTitle: string; JobDescription: string ;Clicked:number}[] = [];
  expandedJobIndex: number | null = null;
  showModal: boolean = false;
  modalReady: boolean = false;
  @Input() set widgetData(data: WidgetInput) {
    this.translateStrings = data.TranslateStrings || {};
    this.jobdescpritionAndTitle = data.jobInformation || [];
    this.pagetype =data.pagetype;
    const hasValidJob = this.jobdescpritionAndTitle.some(
      item => item?.JobTitle && item?.JobDescription?.trim()
    );

    this.showModal = hasValidJob;
    if (hasValidJob) {
      setTimeout(() => {
        this.modalReady = true;
        if (this.closeButton) {
          this.closeButton.nativeElement.focus();
        }
      }, 0);
    }

    const index = this.jobdescpritionAndTitle.findIndex(item => item.Clicked === 1);
    if (index !== -1) {
      this.expandedJobIndex = index;
    }
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.showModal || !this.modalReady) return;

    const clickedInside = this.modalContent?.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.closeModal();
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent): void {
    this.closeModal();
  }
  toggleAccordion(index: number): void {
    this.expandedJobIndex = this.expandedJobIndex === index ? null : index;
  }

  jobdescriptionhandleKeydown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleAccordion(index);
    }
  }

  closeModal(): void {
    this.showModal = false;
    this.modalReady = false;
  }
}
